export function detectDeviceType() {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/android/.test(userAgent)) {
    return "android";
  } else if (/iphone|ipod|ipad/.test(userAgent)) {
    return "ios";
  }
  return "desktop";
}
